import {
  REQUEST_DEVICES,
  RECEIVE_DEVICES,
  DEVICES_FAILED
} from '../actions/types';

function deviceTypesRequest(state = {}, action) {
  switch(action.type) {
    case RECEIVE_DEVICES:
      return Object.assign({}, state, {
        isFetching: false,
        deviceTypes: action.devicetypes
      });
    case REQUEST_DEVICES:
      return Object.assign({}, state, {
        isFetching: true,
        deviceTypes: []
      });
    case DEVICES_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        deviceTypes: null,
        error: action.error
      });
    default: {
      return state;
    }
  }
}

export default deviceTypesRequest;
